var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#222F64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6454 3.56109C11.3935 2.81297 12.6065 2.81297 13.3546 3.56109L20.4389 10.6454C21.187 11.3935 21.187 12.6065 20.4389 13.3546L13.3546 20.4389C12.6065 21.187 11.3935 21.187 10.6454 20.4389L3.56109 13.3546C2.81297 12.6065 2.81297 11.3935 3.56109 10.6454L10.6454 3.56109Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.481 15.7496L15.0119 15.7496C14.8793 15.7496 14.7521 15.6969 14.6583 15.6031L12.3385 13.2832C12.1432 13.088 11.8266 13.088 11.6313 13.2832L9.31147 15.6031C9.2177 15.6969 9.09052 15.7496 8.95791 15.7496L6.51562 15.7496",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5151 8.17231L8.98421 8.17231C9.11681 8.17231 9.24399 8.22498 9.33776 8.31875L11.6576 10.6386C11.8529 10.8339 12.1695 10.8339 12.3647 10.6386L14.6846 8.31875C14.7784 8.22498 14.9056 8.17231 15.0382 8.17231L17.4805 8.17231",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.8556b36a276c97a31d9d65a16fc7a389.svg";
export { ForwardRef as ReactComponent };